import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/environmentWater/icon2_01.png'
import _imports_1 from '../../assets/environmentWater/pic2_03.png'
import _imports_2 from '../../assets/environmentWater/icon2_02.png'
import _imports_3 from '../../assets/environmentWater/pic2_06.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "kv" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "水資源管理")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "sect1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ctx" }, [
    /*#__PURE__*/_createElementVNode("p", null, "以煤炭發電的火力發電廠需要使用大量工業用水，和平電力發電過程中每天約產生 533 噸的作業廢水，為了有效再利用，2021 年起和平電力自行開發並攜手國立宜蘭大學合作研究，使用全台燃煤電廠中唯一「奈米濾膜及逆滲透膜系統」，逐步回收廢水，2023 年相較 2020 年減少 10.4 萬噸排水量。此項系統於 2024 年取得 I832462 號專利，並將作業廢水用於脫硫及海水電解系統。")
  ])
], -1)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "imgContainer2-1" }, null, -1)
const _hoisted_6 = { class: "milestone" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "block0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1)
const _hoisted_8 = { class: "block1" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"left\"><div class=\"item item1 phoneHidden\"><div class=\"year\">2022 年</div><br><div class=\"imgContainer2-2\"><div class=\"imgTit\">與國立宜蘭大學合作研究自力開發奈米濾膜及逆滲透膜系統</div></div></div></div>", 1)
const _hoisted_10 = { class: "right" }
const _hoisted_11 = { class: "item item1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "year" }, "2020 年", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, "作業廢水/年", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "phoneVisable" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-up-long" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "txt2" }, " 產生 ", -1)
const _hoisted_19 = {
  class: "num num1",
  ref: "num1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "unit" }, " 噸", -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"diagram\"><img class=\"icon\" src=\"" + _imports_0 + "\"><span class=\"txt1\">×365</span><span class=\"txt2\">天</span><span class=\"unit\">單位：千噸/桶</span></div>", 1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "item item1L phoneVisable" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "year" }, "2022 年"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "imgContainer2-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "imgTit" }, "與國立宜蘭大學合作研究自力開發奈米濾膜及逆滲透膜系統")
  ])
], -1)
const _hoisted_23 = { class: "item item2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "year" }, "2023 年", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "info" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, "作業廢水/年", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "phoneVisable" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-down-long" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "txt2" }, " 減少 ", -1)
const _hoisted_31 = {
  class: "num num2",
  ref: "num2"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "unit" }, " 噸", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "nextArrow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stick" }),
  /*#__PURE__*/_createElementVNode("div", { class: "tri" })
], -1)
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"block2\"><div class=\"year\">2024 年 4 月</div><img class=\"icon\" src=\"" + _imports_2 + "\"><div class=\"highlight\">建置雨水回收系統</div><div class=\"desp\">蒐集的雨水經過沉沙、除油、過濾後再利用於脫硫系統。</div><div class=\"left\"><div class=\"imgContainer2-4\"><div class=\"imgTit\">雨水回收槽</div></div></div><div class=\"right\"><div class=\"rainDischargeTxt\">雨水排放口改造示意圖</div><img class=\"imgContainer2-6\" src=\"" + _imports_3 + "\"></div><div class=\"clear\"></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18,
                    _createElementVNode("span", _hoisted_19, "533", 512),
                    _hoisted_20
                  ]),
                  _hoisted_21
                ]),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _hoisted_28,
                    _hoisted_29,
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, "104000", 512),
                    _hoisted_32
                  ]),
                  _hoisted_33
                ])
              ]),
              _hoisted_34,
              _hoisted_35
            ]),
            _hoisted_36
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}